import React from "react";
import { Modal, Button } from "react-bootstrap";
import PaymentStepOne from "./payment-step-one";
import PaymentStepTwo from "./payment-step-two";
import PaymentStepThree from "./payment-step-three";
import "./payment-layout.css";

function PaymentLayout(props) {
  const cancelButton = (
    <Button
      className="btn btn-warning"
      onClick={() => props.handleShow("Payment", false)}
    >
      Cancel
    </Button>
  );

  const previousButton = (
    <Button className="btn btn-warning" onClick={() => props.handleStep(-1)}>
      Back
    </Button>
  );

  const nextButton = (
    <Button
      className="btn btn-warning"
      onClick={() => props.handleStep(1)}
      disabled={props.emptyStepOption}
    >
      Next
    </Button>
  );

  const confirmButton = (
    <Button
      disabled={props.paymentInProgress}
      className="btn btn-warning"
      onClick={event => props.confirmPayment(event, props.currentPlan)}
    >
      Make Payment
    </Button>
  );

  return (
    <div>
      <Modal
        show={props.show}
        onHide={() => props.handleShow("Payment", false)}
        className="new-payment-form"
      >
        <Modal.Header closeButton>
          <Modal.Title className="text-primary">
            Make a Payment to {props.currentPlan.provider}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {(() => {
            switch (props.step) {
              case 1:
                return <PaymentStepOne {...props.stepOneParams} />;
              case 2:
                return <PaymentStepTwo {...props.stepTwoParams} />;
              case 3:
                return <PaymentStepThree {...props.stepThreeParams} />;
              default:
                return <PaymentStepOne {...props.stepOneParams} />;
            }
          })()}
        </Modal.Body>
        <Modal.Footer>
          {props.step > 1 ? previousButton : cancelButton}
          {props.step === 3 ? confirmButton : nextButton}
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default PaymentLayout;



// WEBPACK FOOTER //
// ./src/home/components/payment-layout.js